function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.398 5.825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.796 147.33h-.539v.215h.539a.324.324 0 0 0 .323-.323v-.666a.323.323 0 1 0-.216 0v.666c0 .06-.048.108-.107.108M53.418 147.975h.71a.108.108 0 0 0 0-.215h-.71zM52.255 150.512h.538c.06 0 .108.048.108.108v.506a.323.323 0 1 0 .215 0v-.506a.324.324 0 0 0-.323-.323h-.538ZM54.03 149.267h-.556v.215h.557c.059 0 .107.048.107.108v.558a.323.323 0 1 0 .215 0v-.558a.324.324 0 0 0-.322-.323M54.948 148.513a.32.32 0 0 0-.303.216h-1.594v.215h1.594a.322.322 0 1 0 .303-.43",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-49.874 -145.929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.918 149.805a.11.11 0 0 0-.108-.108h-1.076v.216h1.076c.06 0 .108-.049.108-.108M54.989 148.083v-.558a.323.323 0 1 0-.216 0v.558c0 .06-.048.108-.107.108h-1.139v.215h1.139a.324.324 0 0 0 .323-.323M49.955 146.698l2.267-.714a.1.1 0 0 1 .033-.005v1.111c-.813 0-1.474.774-1.474 1.627 0 .854.76 1.574 1.474 1.574v1.403a.1.1 0 0 1-.034-.005c-.818-.268-2.347-1.204-2.347-2.257v-2.62c0-.052.033-.098.08-.114",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-49.874 -145.929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.414 147.249a1.429 1.429 0 1 0 0 2.858 1.429 1.429 0 0 0 0-2.858m.912 2.178a.115.115 0 0 1 0 .163.116.116 0 0 1-.163 0l-.75-.75-.75.75a.116.116 0 0 1-.161 0 .115.115 0 0 1 0-.163l.75-.75-.75-.75a.115.115 0 1 1 .162-.162l.75.75.75-.75a.12.12 0 0 1 .08-.034q.023 0 .045.01a.12.12 0 0 1 .062.062.12.12 0 0 1-.025.125l-.75.75z",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-49.874 -145.929)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.b7ab883b1615648ef74017b5af7d8257.svg";
export { ForwardRef as ReactComponent };